import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createPosition } from "src/Pages/Company/OrganizationStructure/api";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import { AddPosition } from "src/Pages/Company/OrganizationStructure/Positions/positions.models";

const useCreatePosition = (companyId: string, structureId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData: AddPosition) =>
      createPosition(companyId, structureId, formData),
    onSuccess: () => {
      dynamicNotification(__("Pomyślnie dodano stanowisko"), "success");

      queryClient.invalidateQueries({
        queryKey: ["positions-list", companyId, structureId],
      });
    },
    onError: () => {
      dynamicNotification(__("Nie udało się dodać stanowiska"), "error");
    },
  });
};

export default useCreatePosition;
